import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function clickRevealDialogReducer(state = initialState.clickRevealDialog, action) {
    switch(action.type){
        case types.SET_CLICK_REVEAL_DIALOG:
            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new stateconsole.log('UPDATE_PROJECT_SUCCESS')
            return Object.assign({},action.clickRevealDialog);

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/clickRevealDialogReducer.js
 **/